export const portList = [
    {
        "id": 11,
        "code": "PORT00011",
        "name": "Ngọc Hải",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Hải Sơn, Đồ Sơn",
        "phone": "02253 563319",
        "lat": 20.722168512364977,
        "lon": 106.79860037645797,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 12,
        "code": "PORT00012",
        "name": "Trân Châu",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Trân Châu, Cát Hải",
        "phone": "02253 652906",
        "lat": 20.748034847446384,
        "lon": 107.01496404964946,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 13,
        "code": "PORT00013",
        "name": "Bạch Long Vỹ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Bạch Long Vỹ",
        "phone": "02253 889611",
        "lat": 20.124679831229365,
        "lon": 107.72699833670741,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 14,
        "code": "PORT00014",
        "name": "Cửa Lân",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Nam Thịnh, Tiền Hải",
        "phone": "02273 800808",
        "lat": 20.364208146831913,
        "lon": 106.57542675206209,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 15,
        "code": "PORT00015",
        "name": "Ninh Cơ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khu 21, Thịnh Long, Hải Hậu",
        "phone": "02283 799098",
        "lat": 20.02348551037519,
        "lon": 106.20206963709195,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 16,
        "code": "PORT00016",
        "name": "Công ty TNHH hải sản Thành Vui",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT Thịnh Long, Hải Hậu",
        "phone": null,
        "lat": 20.034275286778666,
        "lon": 106.2077948595239,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 17,
        "code": "PORT00017",
        "name": "Lạch Hới",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Quảng Tiến, Sầm Sơn",
        "phone": "02373 790290",
        "lat": 19.774306116734508,
        "lon": 105.9005712659208,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 18,
        "code": "PORT00018",
        "name": "Lạch Bạng",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Hải Bình, Nghi Sơn",
        "phone": "02373 200656",
        "lat": 19.408889,
        "lon": 105.780556,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 19,
        "code": "PORT00019",
        "name": "Hoà Lộc",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Hòa Lộc, Hậu Lộc",
        "phone": "02378 860223",
        "lat": 19.890498157599836,
        "lon": 105.93598962359607,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 20,
        "code": "PORT00020",
        "name": "Hải Châu",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Hải Châu, Tĩnh Gia",
        "phone": null,
        "lat": 19.58273966235903,
        "lon": 105.80451616768664,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 21,
        "code": "PORT00021",
        "name": "Cửa Hội",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Nghi Hải, Cửa Lò",
        "phone": "02383 948322",
        "lat": 18.760424788652696,
        "lon": 105.7520415082209,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 22,
        "code": "PORT00022",
        "name": "Quỳnh Phương",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Quỳnh Phương, Hoàng Mai",
        "phone": "02383 948222",
        "lat": 19.235332776167375,
        "lon": 105.7569058331856,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 23,
        "code": "PORT00023",
        "name": "Lạch Quèn",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tiến Thủy (bắc cảng) và Quỳnh Thuận (nam cảng), Quỳnh Lưu",
        "phone": "02386 295959",
        "lat": 19.107347588253973,
        "lon": 105.71454627939428,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 24,
        "code": "PORT00024",
        "name": "Lạch Vạn",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Diễn Ngọc, Diễn Châu",
        "phone": "02386 258296",
        "lat": 18.997924305605657,
        "lon": 105.60560683002622,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 25,
        "code": "PORT00025",
        "name": "Xuân Hội",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Xuân Hội, Nghi Xuân",
        "phone": "02393 651272",
        "lat": 18.755154431734347,
        "lon": 105.75343822620948,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 26,
        "code": "PORT00026",
        "name": "Cửa Sót (Thạch Kim)",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thạch Kim, Lộc Hà",
        "phone": "02393 651272",
        "lat": 18.451423437734654,
        "lon": 105.9201007793768,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 27,
        "code": "PORT00027",
        "name": "Nhật Lệ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Phú Hải, Đồng Hới",
        "phone": "02323 820920",
        "lat": 17.457386780928427,
        "lon": 106.63241835051555,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 28,
        "code": "PORT00028",
        "name": "Cửa Việt",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Triệu An, Triệu Phong",
        "phone": "02333 869568",
        "lat": 16.90612162203507,
        "lon": 107.18896863701009,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 29,
        "code": "PORT00029",
        "name": "Cửa Tùng",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT Cửa Tùng, Vĩnh Linh",
        "phone": "02333 613967",
        "lat": 17.015065968096955,
        "lon": 107.10734832352064,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 30,
        "code": "PORT00030",
        "name": "Bến cá Chợ cửa Việt",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thị trấn Cửa Việt, huyện Gio Linh, tỉnh Quảng Trị",
        "phone": "914064152",
        "lat": 16.906217628262176,
        "lon": 107.18909384940056,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 31,
        "code": "PORT00031",
        "name": "Thuận An",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT Thuận An, Phú Vang",
        "phone": "02343 856124",
        "lat": 16.551731378148194,
        "lon": 107.64154885366912,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 32,
        "code": "PORT00032",
        "name": "Tư Hiền",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Vinh Hiền, Phú Lộc",
        "phone": "02343 684638",
        "lat": 16.353117349229088,
        "lon": 107.91122372350516,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 33,
        "code": "PORT00033",
        "name": "Thọ Quang",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "18-20 Vân Đồn, Thọ Quang, Sơn Trà",
        "phone": "02363 923066 02363 266185",
        "lat": 16.09968937807603,
        "lon": 108.23967136582736,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 34,
        "code": "PORT00034",
        "name": "Tam Quang",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tam Quang, Núi Thành",
        "phone": "02356 277899",
        "lat": 15.471946106027826,
        "lon": 108.68327128115759,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 35,
        "code": "PORT00035",
        "name": "Mỹ Á",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Phổ Quang, Đức Phổ",
        "phone": "02553 772068",
        "lat": 14.831742684502668,
        "lon": 108.99138936580037,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 36,
        "code": "PORT00036",
        "name": "Lý Sơn",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "An Hải, Lý Sơn",
        "phone": "02553 862686",
        "lat": 15.379509183490097,
        "lon": 109.09544909021439,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 37,
        "code": "PORT00037",
        "name": "Tịnh Hoà",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tịnh Hòa, TP Quảng Ngãi",
        "phone": "02553 867577",
        "lat": 15.207786094698147,
        "lon": 108.88884342348004,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 38,
        "code": "PORT00038",
        "name": "Sa Huỳnh",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Phổ Thạnh, Đức Phổ",
        "phone": "02553 981155",
        "lat": 14.673799079535303,
        "lon": 109.06973653696117,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 39,
        "code": "PORT00039",
        "name": "Tịnh Kỳ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tịnh Kỳ, TP Quảng Ngãi",
        "phone": "02553 688777",
        "lat": 15.210520916131731,
        "lon": 108.90293893697215,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 40,
        "code": "PORT00040",
        "name": "Quy Nhơn",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "26 Hàm Tử, Hải Cảng, Quy Nhơn",
        "phone": "02563 629619",
        "lat": 13.780046367445513,
        "lon": 109.2393935215999,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 41,
        "code": "PORT00041",
        "name": "Đề Gi",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thôn An Quang Đông, Cát Khánh, Phù Cát",
        "phone": "02563 654668",
        "lat": 14.12681923752712,
        "lon": 109.2042730908432,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 42,
        "code": "PORT00042",
        "name": "Tam Quan",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tam Quan Bắc, Hoài Nhơn",
        "phone": "02563 765865",
        "lat": 14.580891122473869,
        "lon": 109.06393578648728,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 43,
        "code": "PORT00043",
        "name": "Phú Lạc",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khu phố Phú Lạc, Hòa Hiệp Nam, Đông Hòa",
        "phone": "02573 567456",
        "lat": 12.953097168963204,
        "lon": 109.41801475042097,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 44,
        "code": "PORT00044",
        "name": "Đông Tác",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khu phố 6, Phú Đông, Tuy Hòa",
        "phone": "02573 851084",
        "lat": 13.076794757652623,
        "lon": 109.33461779645499,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 45,
        "code": "PORT00045",
        "name": "Dân Phước",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khu phố Vạn Phước, Xuân Thành, Sông Cầu",
        "phone": "02573 691937",
        "lat": 13.44010942723754,
        "lon": 109.22467950995353,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 46,
        "code": "PORT00046",
        "name": "Tiên Châu",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thôn Tiên Châu, An Ninh Tây, Tuy An",
        "phone": "02573 607447",
        "lat": 13.352544118490234,
        "lon": 109.25673010810007,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 47,
        "code": "PORT00047",
        "name": "Hòn Rớ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "01 Nguyễn Xí, Phước Đồng, Nha Trang",
        "phone": "02583 828458",
        "lat": 12.200107905240435,
        "lon": 109.19500148109634,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 48,
        "code": "PORT00048",
        "name": "Đá Bạc-Cam Ranh",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Cam Linh, Cam Ranh",
        "phone": null,
        "lat": 11.903154528987514,
        "lon": 109.1430428541076,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 49,
        "code": "PORT00049",
        "name": "Vĩnh Lương",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Vĩnh Lương, Nha Trang",
        "phone": null,
        "lat": 12.334885941934791,
        "lon": 109.20358450993456,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 50,
        "code": "PORT00050",
        "name": "Đại Lãnh",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Đại Lãnh, Vạn Ninh",
        "phone": null,
        "lat": 12.835514545359597,
        "lon": 109.36351530994287,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 51,
        "code": "PORT00051",
        "name": "Cà Ná",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Cà Ná, Thuận Nam",
        "phone": "02593 861060",
        "lat": 0,
        "lon": 0,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 52,
        "code": "PORT00052",
        "name": "Ninh Chữ",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Tỉnh lộ 702, Khánh Hội, Tri Hải, Ninh Hải",
        "phone": "02593 874763",
        "lat": 11.59268529818621,
        "lon": 109.04870110992292,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 53,
        "code": "PORT00053",
        "name": "Đông Hải",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Đông Hải, Phan Rang-Tháp Chàm",
        "phone": "02593 895401",
        "lat": 11.546856908180855,
        "lon": 109.02497310682298,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 54,
        "code": "PORT00054",
        "name": "Mỹ Tân",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thanh Hải, Ninh Hải",
        "phone": "02593 879568",
        "lat": 11.581614127745935,
        "lon": 109.13260962156279,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 55,
        "code": "PORT00055",
        "name": "Phan Thiết",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "75 Trưng Trắc, Đức Thắng, Phan Thiết",
        "phone": "02523 815631",
        "lat": 10.93478719329146,
        "lon": 108.10554925728319,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 56,
        "code": "PORT00056",
        "name": "Phú Hải",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Thanh Hải, TP Phan Thiết",
        "phone": "02523 813170",
        "lat": 10.9308330385037,
        "lon": 108.13408692877414,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 57,
        "code": "PORT00057",
        "name": "La Gi",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "27 Bến Chương Dương, Phước Lộc, La Gi",
        "phone": "02523 842142",
        "lat": 10.654453130239133,
        "lon": 107.7738304368936,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 58,
        "code": "PORT00058",
        "name": "Phan Rí Cửa",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Đường Bạch Đằng, Phan Rí Cửa, Tuy Phong",
        "phone": "02523 855687",
        "lat": 11.167998079462254,
        "lon": 108.56402350806472,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 59,
        "code": "PORT00059",
        "name": "Cát Lở",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "1007/34 đường 30/4, phường 11, TP.Vũng Tàu",
        "phone": "02543 848655",
        "lat": 10.412618459556905,
        "lon": 107.12742541777551,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 60,
        "code": "PORT00060",
        "name": "XN DVHCTS Hưng Thái",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Phước Hưng, Long Điền",
        "phone": "02543 583839",
        "lat": 11.108892420390596,
        "lon": 107.23994498055345,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 61,
        "code": "PORT00061",
        "name": "Xí nghiệp CKTT",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Phường 5, TP.Vũng Tàu",
        "phone": "3540331",
        "lat": 10.380087697178226,
        "lon": 107.07005029390619,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 62,
        "code": "PORT00062",
        "name": "Incomap",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "335C3 Trần Phú, phường 5, TP.Vũng Tàu",
        "phone": "02543 812198",
        "lat": 10.377752609132308,
        "lon": 107.07158112398699,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 63,
        "code": "PORT00063",
        "name": "Bến Đá",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "199 Bạch Đằng, phường 5, TP.Vũng Tàu",
        "phone": "0913 948973",
        "lat": 10.381617512579385,
        "lon": 107.06948907849637,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 64,
        "code": "PORT00064",
        "name": "Tân Phước",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "E2 ấp Tân Lập, Phước Tỉnh, Long Điền",
        "phone": "02543 841277",
        "lat": 10.406371044376234,
        "lon": 107.18605399536285,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 65,
        "code": "PORT00065",
        "name": "Lộc An",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Ấp An Hải, Lộc An, Đất Đỏ",
        "phone": "02543 685064",
        "lat": 10.456483752292486,
        "lon": 107.33615119641479,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 66,
        "code": "PORT00066",
        "name": "Bến Lội (Bình Châu)",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Ấp Thanh Bình 4, Bình Châu, Xuyên Mộc",
        "phone": "02543 685064",
        "lat": 10.54601514176671,
        "lon": 107.54537385038405,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 67,
        "code": "PORT00067",
        "name": "Côn Đảo-Vũng Tàu",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "1007/36 đường 30/4, Phường 11, TP.Vũng Tàu",
        "phone": "02543 621713",
        "lat": 10.413921578415378,
        "lon": 107.12848109539021,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 68,
        "code": "PORT00068",
        "name": "Bến Đầm",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Đường 30/4, khu dân cư số 10, Côn Đảo",
        "phone": "02543 830018",
        "lat": 8.659341396003356,
        "lon": 106.56927189454188,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 69,
        "code": "PORT00069",
        "name": "Phường 6 (Thắng Nhì)",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "413/6 Trần Phú, Thắng Nhì,TP.Vũng Tàu",
        "phone": "02543 551818",
        "lat": 10.373528088715336,
        "lon": 107.07292476964687,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 70,
        "code": "PORT00070",
        "name": "Mỹ Tho",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Đường Mỹ Chánh, phường 2, TP Mỹ Tho",
        "phone": "02733 874380",
        "lat": 10.352666167547143,
        "lon": 106.37868652265405,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 71,
        "code": "PORT00071",
        "name": "Vàm Láng",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Ấp Đôi Ma, Kiểng Phước, Gò Công Đông",
        "phone": "02733 847625",
        "lat": 10.414783187943119,
        "lon": 106.7747843098093,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 72,
        "code": "PORT00072",
        "name": "Ba Tri",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "An Thủy, Ba Tri",
        "phone": "02753 856626",
        "lat": 9.975345499353477,
        "lon": 106.62505302877415,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 73,
        "code": "PORT00073",
        "name": "Bình Đại",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Bình Thắng, Bình Đại",
        "phone": "02753 740942",
        "lat": 10.204500625828036,
        "lon": 106.70558145170307,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 74,
        "code": "PORT00074",
        "name": "Thạnh Phú",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "An Nhơn, Thạnh Phú",
        "phone": "02753 733666",
        "lat": 9.882773222137923,
        "lon": 106.5982960215397,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 75,
        "code": "PORT00075",
        "name": "Định An",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT Định An, Trà Cú",
        "phone": "02943 686038",
        "lat": 10.086328787467101,
        "lon": 106.01698636572218,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 76,
        "code": "PORT00076",
        "name": "Láng Chim",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Khóm 30/4, Phường 2, Duyên Hải",
        "phone": null,
        "lat": 9.682489130456547,
        "lon": 106.53365272338927,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 77,
        "code": "PORT00077",
        "name": "Trần Đề",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "102, đường 30/4, ấp Cảng, Trần Đề, Trần Đề",
        "phone": "02993 846702",
        "lat": 9.529241424495943,
        "lon": 106.20035680064106,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 78,
        "code": "PORT00078",
        "name": "Mỏ Ó",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Trung Bình, Trần Đề",
        "phone": null,
        "lat": 9.424757207022322,
        "lon": 106.16996833687823,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 79,
        "code": "PORT00079",
        "name": "Gành Hào",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Ấp 4, TT Gành Hào, Đông Hải",
        "phone": "02913 844797",
        "lat": 9.042885387273516,
        "lon": 105.41352872338186,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 80,
        "code": "PORT00080",
        "name": "Cà Mau",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "04 Nguyễn Công Trứ, khóm 7, phường 8, TP Cà Mau",
        "phone": "02906 517979",
        "lat": 9.164408336775695,
        "lon": 105.15339023687525,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 81,
        "code": "PORT00081",
        "name": "Rạch Gốc",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khóm 6, TT Rạch Gốc, Ngọc Hiển",
        "phone": "02906 517979",
        "lat": 8.630413223772418,
        "lon": 105.0323285926896,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 82,
        "code": "PORT00082",
        "name": "Sông Đốc",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT Sông Đốc, Trần Văn Thời",
        "phone": "02906 517979",
        "lat": 9.040930673173099,
        "lon": 104.83005065486863,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 83,
        "code": "PORT00083",
        "name": "Cái Đôi Vàm",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Khóm 2, TT Cái Đôi Vàm, Phú Tân",
        "phone": null,
        "lat": 8.858957714110625,
        "lon": 104.80895009639593,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 84,
        "code": "PORT00084",
        "name": "Hố Gùi",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": false,
        "address": "Ấp Mai Hoa, Nguyễn Huân, Đầm Dơi",
        "phone": null,
        "lat": 8.831362319122151,
        "lon": 105.28931438105161,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 85,
        "code": "PORT00085",
        "name": "Tắc Cậu",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "Bình An, Châu Thành",
        "phone": "02973 616190",
        "lat": 9.874491547428503,
        "lon": 105.12749389640736,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    },
    {
        "id": 86,
        "code": "PORT00086",
        "name": "An Thới",
        "province_viName": null,
        "province_id": 1,
        "can_issue_sc": true,
        "address": "TT An Thới, Phú Quốc",
        "phone": "02973 844884",
        "lat": 10.015344264358976,
        "lon": 104.014602123129,
        "state": 1,
        "type": 2,
        "country_id": 1,
        "capacity": null,
        "created_at": null,
        "created_by": null,
        "updated_at": null,
        "updated_by": null,
        "designation_code": null,
        "email": null,
        "facilities": null,
        "metadata": null
    }
];